import React from 'react';
import Spinner from 'react-spinkit';

/**
 * A generic loading page.
 */
const CalculatingLoading = () => (
  <span>
    <Spinner name='circle' className='spinner' fadeIn='none' />
    Calculating
  </span>
);

export default CalculatingLoading;



// WEBPACK FOOTER //
// ./src/containers/pages/calculating-loading.js